export type BackendEnv = 'prod' | 'dev';

const PROD_BACKEND_URL = 'https://chicagojets-backend-350650275935.us-central1.run.app';
const DEV_BACKEND_URL = 'https://chicagojets-backend-dev-350650275935.us-central1.run.app';

/**
 * Gets the current backend URL based on the environment stored in localStorage.
 * Defaults to production.
 */
export const getBackendUrl = (): string => {
    const env = localStorage.getItem('backendEnv') as BackendEnv | null;
    if (env === 'dev') {
        return DEV_BACKEND_URL;
    }
    return PROD_BACKEND_URL;
};

/**
 * Gets the current backend environment ('prod' or 'dev').
 * Defaults to 'prod'.
 */
export const getBackendEnv = (): BackendEnv => {
    return (localStorage.getItem('backendEnv') as BackendEnv | null) || 'prod';
}

/**
 * Sets the backend environment and reloads the page to apply the change.
 * @param env The environment to set.
 */
export const setBackendEnv = (env: BackendEnv) => {
    localStorage.setItem('backendEnv', env);
    window.location.reload();
};